"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function Projects() {
    var paperlessEnvironments = {
        company: "Paperless Environments",
        startDate: "Apr 2020",
        endDate: "Present",
        description: "Helped construction companies manage and organize documents and information in a central repository. Assisted clients in managing a documents lifecycle from creation to removal and everything inbetween.",
    };
    var capco = {
        company: "Capco",
        startDate: "Jun 2018",
        endDate: "Feb 2020",
        description: "Utilized cutting-edge technologies, advanced methodologies and a network of industry partners to quickly and effectively address insurance client's problems. Rapidly prototyped solutions to quickly iterate designs and achieve the best product in the shortest possible time.",
    };
    var sangoma = {
        company: "Sangoma",
        startDate: "Feb 2017",
        endDate: "May 2018",
        description: "Provide resturants with a unified communication system to address the issues of food service in the modern digital age. Helps to bring together online orders, phone reservations, and third-party food deliveries into one service.",
    };
    var projects = [sangoma, capco, paperlessEnvironments];
    var projectDisplayer = function (projects) {
        return projects.map(function (project, i) { return (react_1.default.createElement("div", { className: "projects--project -".concat(project.company), key: i },
            react_1.default.createElement("h4", null, project.company),
            react_1.default.createElement("p", { className: 'project--date' }, "".concat(project.startDate, " - ").concat(project.endDate)),
            react_1.default.createElement("hr", { className: 'line' }),
            react_1.default.createElement("p", null, project.description))); });
    };
    return (react_1.default.createElement("section", { className: "projects", id: "projects" },
        react_1.default.createElement("h1", { className: 'projects--title' }, "EXPERIENCE"),
        react_1.default.createElement("div", { className: 'projects--container' }, projectDisplayer(projects))));
}
exports.default = Projects;
